import { BASE_API_URL } from "@/common/urls";
export default class FilesHelpers {
  buildUrl(card, file) {
    return `${BASE_API_URL}/files/${card.board_id}/${card.id}/${file.name}`;
  }

  isImage(file) {
    return /\.(gif|jpg|jpeg|tiff|png)$/i.test(file.name);
  }

  isPdf(file) {
    return /\.(pdf)$/i.test(file.name);
  }
}
